import { baseApi } from '@shared/api'
import { ActionStatus } from 'pages/BusinessCards/components/LimitsPage/constants/constantForLimits'

export const limitsCardApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchCardLimits: builder.query<any,  string >({
        query: (pan) => ({
          url: '/ib/cards/limits/info',
          data: { pan } ,
          method: 'POST',
          skipGlobalError:true,
        }),
        providesTags: ['BusinessCardLimitInfo'],
      }),
      fetchCheckCard: builder.mutation<any, { requestData: any }>({
        query: ({ requestData }) => ({
          url: '/ib/cards/block/check',
          method: 'POST',
          data:requestData,
          skipGlobalError:true
        }),
      }),
      fetchCardBlockUpdate: builder.mutation<any, { updateRequestData: any }>({
        query: ({ updateRequestData }) => ({
          url: '/ib/cards/block/update',
          method: 'POST',
          data:updateRequestData,
          skipGlobalError: true
        }),
        // invalidatesTags: ['BusinessCardLimitInfo']
        async onQueryStarted({ updateRequestData }, { dispatch, queryFulfilled }) {
            try {
              await queryFulfilled
              dispatch(
                limitsCardApi.util.updateQueryData('fetchCardLimits',   updateRequestData?.pan , draft => {
                  Object.assign(draft, {
                    ...draft,
                    generInfo: {
                      ...draft.generInfo,
                      isBlocked: updateRequestData?.operationType === ActionStatus.BLOCKING ? true : false,
                    },
                  })
                })
              )
            } catch {}
          },
      }),
      setLimitForBusinnessCard:builder.mutation<any, { requestData: any }>({
        query: ({ requestData }) => ({
          url: '/ib/cards/limits/set',
          method: 'POST',
          data:requestData,
          skipGlobalError:true
        }),
        // invalidatesTags: ['BusinessCardLimitInfo']
      }),
      fetchByDocType: builder.mutation<any,  { isClickCardBlockButton: boolean; docType: string; }>({
        query: (docTypeRequest) => ({
          url: '/ib/cards/director/by-doctype',
          data: docTypeRequest,  
          method: 'POST',
          skipGlobalError: true
        }),
      }),
      disabledLimitForBusinnessCard:builder.mutation<any, { requestData: any }>({
        query: ({ requestData }) => ({
          url: '/ib/cards/limits/disable',
          method: 'POST',
          data:requestData,
          skipGlobalError: true,
  
        }),
        // invalidatesTags: ['BusinessCardLimitInfo']
      }),
    }
  },
})

export const {
  useFetchCardLimitsQuery,
  useLazyFetchCardLimitsQuery,
  useFetchCheckCardMutation,
  useFetchCardBlockUpdateMutation,
  useSetLimitForBusinnessCardMutation,
  useDisabledLimitForBusinnessCardMutation,
  useFetchByDocTypeMutation
} = limitsCardApi
